import { Controller } from '@hotwired/stimulus';

const SEARCH_DELAY_MS = 350;
const SIDE_BY_SIDE = '(min-width: 1024px)';

// Alert inbox: filters submit on change (search after a pause) and the row
// picked stays highlighted while its detail loads in the side frame. Below
// lg the detail frame is hidden, so rows open the alert as a page instead.
export default class extends Controller {
  static targets = ['form', 'row']

  connect() {
    this.layout = window.matchMedia(SIDE_BY_SIDE);
    this.onLayoutChange = () => this.rowTargets.forEach((row) => this.#target(row));
    this.layout.addEventListener('change', this.onLayoutChange);
    this.onLayoutChange();
  }

  disconnect() {
    clearTimeout(this.searchTimer);
    this.layout?.removeEventListener('change', this.onLayoutChange);
  }

  rowTargetConnected(row) {
    this.#target(row);
  }

  submit() {
    this.formTarget.requestSubmit();
  }

  search() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.submit(), SEARCH_DELAY_MS);
  }

  select(event) {
    this.rowTargets.forEach((row) => row.setAttribute('aria-current', String(row === event.currentTarget)));
  }

  #target(row) {
    if (!this.layout) return;

    row.dataset.turboFrame = this.layout.matches ? 'alert-detail' : 'content-turbo-frame';
  }
}
